import { showPanel } from '@/pages/shared/shared.reducer';
import panels from '@/constants/panels';
import { openErrorNotification } from '@/notification';

// The job-summary slice is loaded on demand so it stays out of the startup bundle.
export const openJobCreatePanel = async (dispatch, documents) => {
  let jobSummary;
  try {
    jobSummary = await import('@/pages/job-summary/job-summary.reducer');
  } catch {
    openErrorNotification('Unable to open job creation. Please refresh and try again.');
    return;
  }

  const { clearRecord, validateDocuments, setValue, changeJobValue } = jobSummary;
  dispatch(clearRecord());
  dispatch(validateDocuments(documents));
  const siteId = documents?.[0]?.siteId;
  if (siteId) {
    dispatch(setValue('siteId', siteId));
    dispatch(changeJobValue('siteId', siteId));
  }
  dispatch(showPanel(panels.jobCreate));
};
